import { supabase } from "../lib/api";

export const updateUserPoints = async (props: {
  newPointsCount: number;
  newTotalPointsCount?: number;
}) => {
  const { newPointsCount, newTotalPointsCount } = props;

  if (newTotalPointsCount) {
    return await supabase.auth.updateUser({
      data: { points: newPointsCount, total_points: newTotalPointsCount },
    });
  } else {
    return await supabase.auth.updateUser({
      data: { points: newPointsCount },
    });
  }
};
